'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var Typography = require('../../../common/components/Typography.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ClaimTypeLabel = _ref => {
  let {
    claimType
  } = _ref;
  const {
    claimsClaimTypeItemDamaged,
    claimsClaimTypeItemMissing,
    claimsClaimTypePackageMissing,
    claimsClaimTypeWrongItem
  } = nthHookTranslations.useTranslations();
  const mapping = {
    ItemDamaged: claimsClaimTypeItemDamaged ?? '',
    ItemMissing: claimsClaimTypeItemMissing ?? '',
    PackageMissing: claimsClaimTypePackageMissing ?? '',
    WrongItem: claimsClaimTypeWrongItem ?? ''
  };
  return /*#__PURE__*/React__default["default"].createElement(Typography.BodyTextDefault, null, mapping[claimType]);
};
var ClaimTypeLabel$1 = nthHookTranslations.withTranslationsProvider(ClaimTypeLabel, {
  translationKeys: ['claimsClaimTypeItemDamaged', 'claimsClaimTypeItemMissing', 'claimsClaimTypePackageMissing', 'claimsClaimTypeWrongItem']
});

exports["default"] = ClaimTypeLabel$1;
